import {
  MONTH_SUMMARY_ALL,
  MONTH_SUMMARY_GET,
  MONTH_SUMMARY_POST,
  MONTH_SUMMARY_PUT,
  MONTH_SUMMARY_LOADING,
  MONTH_SUMMARY_ERROR,
} from '../../actions/types';

const initialState = {
  monthSummary: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case MONTH_SUMMARY_LOADING:
      return { isLoading: true, isCompleted: true };
    case MONTH_SUMMARY_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case MONTH_SUMMARY_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case MONTH_SUMMARY_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case MONTH_SUMMARY_POST:
      return { isLoading: false, isCompleted: true };
    case MONTH_SUMMARY_PUT:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
